import { FC } from 'react'
import styled from 'styled-components'
import { checkCategoryDepthAndShowWarning } from '../../module/utils'
import useJobCategoryStore from '../../store/store.jobCategory'
import { TJobCategory } from '../../type/jobCategoryStoreType'
import DrawCategoryItem, { TDrawCategoryItemInfo } from './DrawCategoryItem'

interface IFCategoryItemAllProps {
  parentCategory: TJobCategory
  className?: string
}

const CategoryItemAll: FC<IFCategoryItemAllProps> = ({
  parentCategory,
  className,
}) => {
  const { id, isSelect, depth, selectedChildrenIds } = parentCategory

  checkCategoryDepthAndShowWarning(depth, [2])

  const selectId = useJobCategoryStore((state) => state.selectId)
  const unSelectId = useJobCategoryStore((state) => state.unSelectId)
  const unSelectIdWithChildren = useJobCategoryStore(
    (state) => state.unSelectIdWithChildren,
  )

  const isSelectAll = selectedChildrenIds.length === 0 && isSelect

  const categoryItem: TDrawCategoryItemInfo = {
    id,
    name: '전체',
    isSelect: isSelectAll,
  }

  const handleSelectCategory = (categoryItemId: string) => {
    if (isSelectAll) {
      return unSelectId(categoryItemId)
    }
    if (selectedChildrenIds.length > 0) {
      unSelectIdWithChildren(categoryItemId)
    }
    selectId(categoryItemId)
  }

  return (
    <StyledWrapper
      categoryItem={categoryItem}
      onClick={handleSelectCategory}
      className={className}
    />
  )
}

export default CategoryItemAll

const StyledWrapper = styled(DrawCategoryItem)``
